import React from 'react';
import MobileNavigation from './MobileNavigation';
import DesktopNavigation from './DesktopNavigation';

const Navigation: React.FC = () => {
  return (
    <>
      <MobileNavigation />
      <DesktopNavigation />
    </>
  );
};

export default Navigation;